<template>
  <div class="user-profile"></div>
</template>

<script>
export default {
  name: 'DashboardUser'
}
</script>

<style scoped>

</style>
